import { useState } from 'react'
import { ConfigurationMode } from '..'

interface State {
  previousConfigurationMode: ConfigurationMode
  configurationMode: ConfigurationMode
}

type UseAddAgentConfigurationMode = () => UseAddAgentConfigurationModeResponse

export interface UseAddAgentConfigurationModeResponse {
  previousConfigurationMode: ConfigurationMode
  configurationMode: ConfigurationMode
  updateConfigurationMode: (newConfigurationMode: ConfigurationMode) => void
  reset: () => void
}

export const useAddAgentConfigurationMode: UseAddAgentConfigurationMode =
  () => {
    const [state, setState] = useState<State>({
      previousConfigurationMode: 'preconfigured',
      configurationMode: 'preconfigured'
    })

    return {
      previousConfigurationMode: state.previousConfigurationMode,
      configurationMode: state.configurationMode,
      updateConfigurationMode: (newConfigurationMode: ConfigurationMode) =>
        setState({
          ...state,
          configurationMode: newConfigurationMode
        }),
      reset: () =>
        setState({
          ...state,
          previousConfigurationMode: 'preconfigured',
          configurationMode: 'preconfigured'
        })
    }
  }
